import api from "@/utils/backend-api";
import {Order} from "@/models";
import {
  sendSuccessNotice,
  sendErrorNotice,
  closeNotice,
  getDefaultPagination,
  commitPagination,
} from "@/utils/store-util.js";

import { get } from "lodash";

const state = {
  banks: [],
  workers: [],
  perdays: [],
  resume: [],
  loading: false,
};

const getters = {
};

const actions = {
  getBanksDoughnut ({ commit }, searchQuery) {
    commit("setLoading", true);
    commit("setBanks", []);
    api.getData("dashboard/banks?" + searchQuery).then(res => {
      const banks = res.data;
      commit("setBanks", { banks });
      commit("setLoading", false);
    });
  },
  getWorkersDoughnut ({ commit }, searchQuery) {
    commit("setWorkers", []);
    api.getData("dashboard/workers?" + searchQuery).then(res => {
      const workers = res.data;
      commit("setWorkers", { workers });
    });
  },
  getPerdaysLineChart ({ commit }, searchQuery) {
    api.getData("dashboard/perdays?" + searchQuery).then(res => {
      const perdays = res.data;
      commit("setPerdays", { perdays });
    });
  },
  getResume ({ commit }, searchQuery) {
    api.getData("dashboard/resume?" + searchQuery).then(res => {
      const resume = res.data;
      commit("setResume", { resume });
    });
  },
};

const mutations = {
  setBanks (state, banks) {
    state.banks = banks;
  },
  setWorkers (state, workers) {
    state.workers = workers;
  },
  setPerdays (state, perdays) {
    state.perdays = perdays;
  },
  setResume (state, resume) {
    state.resume = resume;
  },
  setLoading (state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};


// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js